import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigator } from './navigation';

const NavigationBinder = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);
  return null;
};

export default NavigationBinder;

